import React from 'react'
import './despre_noi.css'

const Despre_noi = () => {
  return (
      <div className='betel__despre_noi section__padding' id='despre_noi'>
        <div className='betel__despre_noi-info'  >
          <h1>Suntem aici pentru a proclama și a demonstra puterea eliberatoare a Evangheliei – iubindu-L  pe Dumnezeu,
              iubind oamenii și făcând ucenici!</h1>
        </div>
        <div className='betel__despre_noi-welcome'>
          <p>Bine ai venit pe site-ul Bisericii Penticostale Betel Mallorca - Spania, o biserică dedicată proclamării
              Cuvântului lui
              Dumnezeu.<br></br> Dorim ca toți, de la cei mai mici până la cei mai în vârstă, să poată auzi, înțelege și trăi în
              mod autentic Cuvântul lui Dumnezeu. Pentru că ai preț în ochii lui Dumnezeu și în ochii noștri, în biserica
              noastră vei experimenta în mod real dragostea, bunătatea și grija lui Dumnezeu. Alături de noi vei înțelege
              ce înseamnă să aparții cu adevărat unei comunități vii, care se închină în unitate și-L slujește pe Dumnezeu
              cu pasiune. Fiecare dintre noi se află într-o călătorie spirituală, dar indiferent unde te afli în drumul
              tău spiritual, împreună cu noi poți să crești, să zidești relații semnificative și să fii de folos semenilor
              tăi.</p>
        </div>
      </div>
  )
}

export default Despre_noi